import { DEFAULT_DEVICE_ID, DeviceType } from 'src/app/common/utils/devices-handle-util';
import { DEFAULT_MIC_ID_KEY } from 'src/app/models/device-manger';
import { BaseLocalTrack } from './local-track';

export class LocalAudioTrackService extends BaseLocalTrack {
  constructor() {
    const deviceId = localStorage.getItem(DEFAULT_MIC_ID_KEY) ?? DEFAULT_DEVICE_ID;
    super(DeviceType.AUDIO, deviceId);
  }

  getStreamConstrains(): MediaTrackConstraints | undefined {
    return undefined;
  }

  setDeviceIdIntoLocalStorage(deviceId: string) {
    localStorage.setItem(DEFAULT_MIC_ID_KEY, deviceId);
  }
}
